import { useSelector } from "react-redux";
import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import Toggle from "src/components/toggles/Toggle";
import { hasEditAccess } from "src/redux/selectors/app";
import ActionsCell from "./ActionsCell";
import { CourseType } from "./courses-types";

const useCourseTableColumns = ({
  onDelete,
  handleCourseStatusChange,
}: {
  onDelete: (id: number) => void;
  handleCourseStatusChange: (courseId: number, status: boolean) => void;
}) => {
  const hasEditPermission = useSelector(hasEditAccess);

  return [
    {
      Header: "Course Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Duration",
      accessor: "duration",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Required Items",
      accessor: "requiredItems",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<CourseType>) => (
        <TextCell value={original.products.length} />
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<CourseType>) => {
        return (
          <div className="flex justify-center">
            <Toggle
              checked={value}
              onToggle={(value) =>
                handleCourseStatusChange(row.original.id, value)
              }
              disabled={!hasEditPermission}
              tooltip={
                hasEditPermission ? "" : "You don't have permission to edit."
              }
              showToggleStatus
            />
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<CourseType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useCourseTableColumns;
